// extracted by mini-css-extract-plugin
export default {"figure":"los-angeles-module--figure--bc9Hf","capabilities":"los-angeles-module--capabilities--B7cbW","weAre":"los-angeles-module--we-are--yfDAE"};